import {
  BarChart3,
  CalendarClock,
  CalendarDays,
  Clock3,
  FileSignature,
  Plane,
  Users,
  WalletCards,
} from "lucide-react";
import type { AdminPanelSection } from "../types/admin-panel";

export const adminPanelSections: AdminPanelSection[] = [
  {
    id: "usuarios",
    title: "Usuarios",
    subtitle: "Listado y permisos",
    icon: Users,
  },
  {
    id: "fichajes",
    title: "Fichajes",
    subtitle: "Control horario, retrasos, faltas y justificaciones",
    icon: Clock3,
  },
  {
    id: "horarios",
    title: "Horarios",
    subtitle: "Gestión de turnos por empleado",
    icon: CalendarClock,
  },
  {
    id: "agenda",
    title: "Agenda",
    subtitle: "Eventos y reuniones de la plantilla",
    icon: CalendarDays,
  },
  {
    id: "nominas",
    title: "Nóminas",
    subtitle: "Gestión de documentos",
    icon: WalletCards,
  },
  {
    id: "contratos",
    title: "Contratos",
    subtitle: "Altas y consulta",
    icon: FileSignature,
  },
  {
    id: "vacaciones",
    title: "Vacaciones",
    subtitle: "Solicitudes, calendario y saldo",
    icon: Plane,
  },
  {
    id: "estadisticas",
    title: "Estadísticas",
    subtitle: "Asistencia, incidencias y vacaciones",
    icon: BarChart3,
  },
];
